var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.088,
    x2: 257.755,
    y1: 207.521,
    y2: 364.126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2346,
    stopColor: "#fe653c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    stopColor: "#fb4628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.067,
    x2: 147.067,
    xlinkHref: "#lg1",
    y1: 260.848,
    y2: -21.152
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.823,
    x2: 308.823,
    y1: 149.454,
    y2: 443.816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 228.172,
    y2: -8.622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.281,
    x2: 22.281,
    xlinkHref: "#lg1",
    y1: 344.357,
    y2: 213.69
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 -1 412.278 -2566.914)",
    gradientUnits: "userSpaceOnUse",
    x1: 124.559,
    x2: -75.441,
    xlinkHref: "#lg1",
    y1: -2880.622,
    y2: -3011.289
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 350,
    y2: 406.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1249,
    stopColor: "#ed2819",
    stopOpacity: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    stopColor: "#d42724",
    stopOpacity: 0.452
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#c5272b",
    stopOpacity: 0.753
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.858,
    x2: 255.858,
    xlinkHref: "#lg2",
    y1: 402.977,
    y2: 440.651
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 432.147,
    y2: 469.821
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.284,
    x2: 273.938,
    xlinkHref: "#lg3",
    y1: 64.298,
    y2: 64.298
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(0 1 -1 0 -1086 -1596)",
    gradientUnits: "userSpaceOnUse",
    x1: 1850.872,
    x2: 1893.525,
    xlinkHref: "#lg3",
    y1: -1555.29,
    y2: -1555.29
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(0 1 -1 0 -1086 -1596)",
    gradientUnits: "userSpaceOnUse",
    x1: 1850.872,
    x2: 1893.525,
    xlinkHref: "#lg3",
    y1: -1126.71,
    y2: -1126.71
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -873.542 -573.082)",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.506,
    x2: 1419.159,
    xlinkHref: "#lg3",
    y1: -410.068,
    y2: -410.068
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -512.918 -2469.543)",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.506,
    x2: 1419.159,
    xlinkHref: "#lg3",
    y1: -2271.932,
    y2: -2271.932
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.09 420.351h-270.18v-140.667c0-74.608 60.482-135.09 135.09-135.09 74.608 0 135.089 60.482 135.089 135.09v140.667z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.84 159.577c-25.103-12.945-54.538-12.945-79.642 0-43.502 22.433-73.25 67.789-73.25 120.107v140.667h226.142v-140.667c0-52.319-29.748-97.674-73.25-120.107z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 144.594c-9.404 0-18.582.966-27.444 2.795 61.448 12.681 107.646 67.091 107.646 132.295v140.667h54.887v-140.667c.001-74.608-60.481-135.09-135.089-135.09z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 222.749,
    fill: "url(#SVGID_4_)",
    rx: 94.346,
    ry: 68.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.733 365.543-64.803 13.282c-19.528 4.002-37.815-10.917-37.815-30.851v-37.884c0-19.934 18.287-34.853 37.815-30.851l64.803 13.282c7.258 1.487 12.468 7.874 12.468 15.283v42.456c0 7.409-5.211 13.796-12.468 15.283z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.267 292.522 64.803-13.282c19.528-4.002 37.815 10.917 37.815 30.851v37.884c0 19.934-18.287 34.853-37.815 30.851l-64.803-13.282c-7.258-1.487-12.468-7.874-12.468-15.283v-42.456c0-7.409 5.211-13.796 12.468-15.283z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m119.91 300h270.179v120.351h-270.179z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.711 457.242h-297.706v-28.503c0-16.479 13.359-29.837 29.837-29.837h238.032c16.479 0 29.837 13.359 29.837 29.837z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.071 486.412h-348.142c-8.23 0-14.903-6.672-14.903-14.903v-13.6c0-16.479 13.359-29.837 29.837-29.837h318.273c16.479 0 29.837 13.359 29.837 29.837v13.6c.001 8.231-6.671 14.903-14.902 14.903z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 105.009c-8.598 0-15.567-6.97-15.567-15.567v-50.287c0-8.598 6.97-15.567 15.567-15.567 8.598 0 15.567 6.97 15.567 15.567v50.286c0 8.598-6.969 15.568-15.567 15.568z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m428.579 278.588c0-8.598 6.97-15.567 15.567-15.567h50.286c8.598 0 15.567 6.97 15.567 15.567 0 8.598-6.97 15.567-15.567 15.567h-50.286c-8.597 0-15.567-6.97-15.567-15.567z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 278.588c0-8.598 6.97-15.567 15.567-15.567h50.286c8.598 0 15.567 6.97 15.567 15.567 0 8.598-6.97 15.567-15.567 15.567h-50.286c-8.597 0-15.567-6.97-15.567-15.567z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m377.739 155.849c-6.079-6.079-6.079-15.936 0-22.015l35.558-35.558c6.079-6.079 15.936-6.079 22.015 0 6.079 6.079 6.079 15.936 0 22.015l-35.558 35.558c-6.079 6.079-15.936 6.079-22.015 0z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.688 98.275c6.079-6.079 15.936-6.079 22.015 0l35.558 35.558c6.079 6.079 6.079 15.936 0 22.015-6.079 6.079-15.936 6.079-22.015 0l-35.558-35.558c-6.08-6.078-6.08-15.935 0-22.015z",
    fill: "url(#SVGID_14_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon-alarm.e6aa9b42bd620f60754a69730a40d5cb.svg";
export { ForwardRef as ReactComponent };